(function () {
  'use strict';

  function initSupportCenter(root) {
    if (!root || root.dataset.supportReady === 'true') return;
    root.dataset.supportReady = 'true';
    var labels = JSON.parse(root.querySelector('[data-support-i18n]').textContent);

    var search = root.querySelector('[data-support-search]');
    var modelButtons = Array.prototype.slice.call(root.querySelectorAll('[data-support-model]'));
    var resources = Array.prototype.slice.call(root.querySelectorAll('[data-support-resource]'));
    var resultStatus = root.querySelector('[data-support-result-status]');
    var selectedModel = 'all';

    function filterResources() {
      var term = search ? search.value.trim().toLowerCase() : '';
      var visible = 0;

      resources.forEach(function (resource) {
        var modelMatch = selectedModel === 'all' || (resource.dataset.models || '').split(' ').indexOf(selectedModel) !== -1;
        var text = (resource.textContent + ' ' + (resource.dataset.keywords || '')).toLowerCase();
        var termMatch = !term || text.indexOf(term) !== -1;
        resource.hidden = !(modelMatch && termMatch);
        if (!resource.hidden) visible += 1;
      });

      if (resultStatus) {
        resultStatus.textContent = visible === 0
          ? labels.no_results
          : labels.results_count.replace('__COUNT__', visible);
      }
    }

    modelButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        selectedModel = button.dataset.supportModel;
        modelButtons.forEach(function (item) {
          item.setAttribute('aria-pressed', item === button ? 'true' : 'false');
        });
        filterResources();
      });
    });

    if (search) search.addEventListener('input', filterResources);
    filterResources();

    var precheckButton = root.querySelector('[data-support-run-precheck]');
    var orderInput = root.querySelector('[data-support-order]');
    var result = root.querySelector('[data-support-precheck-result]');
    var requestForm = root.querySelector('[data-support-request-form]');
    var formOrder = root.querySelector('[data-support-form-order]');
    var formType = root.querySelector('[data-support-form-type]');

    if (requestForm && requestForm.querySelector('.begode-support__form-message')) {
      requestForm.hidden = false;
    }

    function showResult(html, eligible) {
      if (!result) return;
      result.innerHTML = html;
      result.hidden = false;
      result.dataset.eligible = eligible ? 'true' : 'false';
    }

    if (precheckButton) {
      precheckButton.addEventListener('click', function () {
        var channel = root.querySelector('input[name="support_purchase_channel"]:checked');
        var requestType = root.querySelector('input[name="support_request_type"]:checked');
        var order = orderInput ? orderInput.value.trim() : '';
        var normalizedOrder = order.replace(/^#/, '');
        var orderLooksValid = /^\d{3,}$/.test(normalizedOrder);

        if (requestForm) requestForm.hidden = true;

        if (!channel || !requestType || !order) {
          showResult(labels.incomplete_html, false);
          return;
        }

        if (channel.value !== 'begode.com') {
          showResult(labels.ineligible_html, false);
          return;
        }

        if (!orderLooksValid) {
          showResult(labels.invalid_order_html, false);
          return;
        }

        if (requestType.value === 'ongoing') {
          showResult(labels.ongoing_html.replace('__ORDER__', '#' + normalizedOrder), true);
          return;
        }

        showResult(labels.passed_html, true);
        if (formOrder) formOrder.value = order.charAt(0) === '#' ? order : '#' + order;
        if (formType) formType.value = 'First fault report';
        if (requestForm) {
          requestForm.hidden = false;
          requestForm.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
        }
      });
    }
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-begode-support-center]').forEach(initSupportCenter);
  }

  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }
})();
